module.exports = __webpack_public_path__ + "static/media/emoji_neutral.64e506dd.png";